(() => {
  document.addEventListener("DOMContentLoaded", () => {
    const swiper = new Swiper(".shop_all_body .swiper-container", {
      a11y: false,
      spaceBetween: 0,
      slidesPerView: "auto",
      navigation: {},
    });

    const buttons = document.querySelectorAll(".btn__collection");
    const cards = document.querySelectorAll(".static_product_card_container");

    function applyFilter(filter) {
      cards.forEach((card) => {
        const tags = (card.dataset.filterTags || "").split(" ").filter(Boolean);
        const visible = filter === "all" || tags.includes(filter);
        card.classList.toggle("visible", visible);
        card.style.display = visible ? "" : "none";
      });
    }

    function setActiveButton(filter) {
      buttons.forEach((b) => b.classList.remove("active"));
      const btnToActivate = document.querySelector(
        `.btn__collection[data-filter="${filter}"]`
      );
      if (btnToActivate) {
        btnToActivate.classList.add("active");
        const index = Array.from(buttons).indexOf(btnToActivate);
        if (index !== -1) swiper.slideTo(index, 0);
      }
      return btnToActivate;
    }

    function getURLParam(key) {
      const params = new URLSearchParams(window.location.search);
      return params.get(key);
    }

    function setFilter(filter, { scroll } = {}) {
      applyFilter(filter);
      setActiveButton(filter);

      const params = new URLSearchParams(window.location.search);
      if (filter === "all") {
        params.delete("filter");
      } else {
        params.set("filter", filter);
      }

      const newQuery = params.toString();
      const newUrl = newQuery
        ? `${window.location.pathname}?${newQuery}`
        : window.location.pathname;
      window.history.replaceState({}, "", newUrl);

      if (scroll) {
        const filterSection = document.querySelector(".collection__filter");
        if (filterSection) {
          window.scrollTo({
            top: filterSection.offsetTop - 100,
            behavior: "smooth",
          });
        }
      }
    }

    buttons.forEach((btn) => {
      btn.addEventListener("click", () => {
        setFilter(btn.dataset.filter);
      });
    });

    const defaultFilter = getURLParam("filter") || "all";
    const hasMatch = document.querySelector(
      `.btn__collection[data-filter="${defaultFilter}"]`
    );

    setFilter(hasMatch ? defaultFilter : "all", { scroll: !!hasMatch });
  });
})();
